import tokens from './motionTokens.json';

export const DURATIONS: Record<string, string> = tokens.duration;

export const DELAYS: Record<string, string> = tokens.delay;
